/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Group, Modal, Text } from "@mantine/core";
import { useState } from "react";
type deleteModalProps = {
  modalOpened: boolean;
  title: string;
  body: string;
  setModalOpened: (value: boolean) => void;
  onDelete: () => Promise<void>;
};

const ConfirmDeleteModal = (props: deleteModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { modalOpened, setModalOpened, onDelete, title, body } = props;

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(false);
      }}
      title={title}
    >
      <Box>
        <Text fw={400} fz={14}>
          {body}
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(false)}>
            No
          </Button>
          <Button
            loading={isLoading}
            disabled={isLoading}
            onClick={async () => {
              setIsLoading(true);
              await onDelete();
              setIsLoading(false);
            }}
          >
            Yes
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default ConfirmDeleteModal;
